import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import { BizMessageRequestType } from '@/lib/types/auth';

export const bizMessageTypeAtom = atomWithStorage<BizMessageRequestType>(
  'refund_biz-message_request-type',
  'checkDecision',
  createJSONStorage(() => sessionStorage)
);
